import { systemApi } from "@/core/apis";

// getter types
export const HELP_VIDEOS = "helpVideos";

// action types
export const GET_HELP_VIDEOS = "getHelpVideos";

// mutation types
const VIDEOS = "videos";

const state = {
  videos: []
};

const getters = {
  [HELP_VIDEOS](state) {
    return state.videos;
  }
};

const actions = {
  [GET_HELP_VIDEOS](context) {
    return new Promise(resolve => {
      systemApi.getHelpInfo().then(response => {
        context.commit(VIDEOS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [VIDEOS](state, videos) {
    state.videos = videos;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
